export default {
  process: {
    step1: '背景及道路',
    step2: '布局元素',
    step3: '设置出口',
    next: '下一步',
    previous: '上一步',
    finish: '完成',
    nextWarning: '请先放置元素进布局区域内。',
  },
  tool: {
    select: '选中',
    erase: '擦除',
    selectTip: '可在布局区域点击或拖拽选择所需的格子，放置区域。',
    ok: '确认',
  },
  step1Editor: {
    edit1: {
      title: '设置网格',
      rowColumnNum: '行列数',
      row: '行',
      column: '列',
      gridSize: '格子大小',
    },
    edit2: {
      title: '设置底图',
      size: '尺寸',
      sizeScreenSplit: '[尺寸]参数横竖屏拆分',
    },
    edit3: {
      title: '设置道路',
      chooseRoad: '选择道路',
      chooseArea: '选择区域',
      rules: '元素放置规则',
      onRoad: '元素只能放在道路上',
      notOnRoad: '元素不能放在道路上',
      notOnRoadTip: '元素不能放在道路上的问号提示内容',
      area: '区域',
    },
  },
  step2Editor: {
    edit1: {
      title: '运动方向',
      titleTip:
        '若启用，元素的运动方向则有以下5个方向可以选择；若不启用，元素的运动方向仅支持直行1个方向',
      uploadForward: '请上传直行箭头',
      uploadTurnLeft: '请上传向左调头箭头',
      uploadTurnRight: '请上传向右调头箭头',
      uploadLeft: '请上传向左转弯箭头',
      uploadRight: '请上传向右转弯箭头',
      Forward: '直行箭头',
      TurnLeft: '向左调头箭头',
      TurnRight: '向右调头箭头',
      Left: '向左转弯箭头',
      Right: '向右转弯箭头',
      setting: {
        title: '外观',
        applyToAll: '应用到所有箭头',
      },
    },
    edit2: {
      title: '设置主元素',
      elementTip: '判断运行时是否启用，关闭后，则禁用该元素。',
      gridNum: '占坑数量',
      pivot: '箭头锚点',
      pivotDesc: '绿点为箭头<br/>可移动绿点调整箭头出现位置',
    },
    edit3: {
      title: '设置障碍类',
    },
    addCustomEleType: '添加自定义元素类型',
    customEle: {
      eleName: '自定义元素分类',
      dialog: {
        title: '管理自定义元素类型',
      },
    },
    addGroupDialog: {
      mainTitle: '添加主元素分类',
      obsTitle: '添加障碍类',
      customTitle: '添加自定义元素分类',
      categoryName: '分类名称',
      gridNum: '占据网格数',
      categoryNamePlaceholder: '请输入分类名称',
      gridNumPlaceholder: '请输入占据网格数',
      emptyWarning: '不能为空',
      integer: '必须是整数',
    },
    nextWarning: '当前元素摆放异常，请检查确认无误后再进行下一步操作。',
    deleteMainWarningTitle: '删除主元素组',
    deleteMainWarningText:
      '该元素组已被添加进布局内，删除后可能会导致可玩广告无法正常试玩。确认删除吗？',
    elementSetting: {
      title: '外观',
      moveDirSelect: '运动方向选择',
      forward: '直行',
      turnLeft: '向左调头',
      turnRight: '向右调头',
      left: '向左转弯',
      right: '向右转弯',
      backSetting: '倒退设置',
      backSettingTip: '判断元素在试玩过程中是否支持反方向移动。',
      turn: '原地调头',
      noTurn: '退后',
      applyToAll: '应用到全部',
      reset: '重置',
    },
  },
  step3Editor: {
    title: '出口设置',
    titleTip: '将主元素与不同类型的出口进行匹配。',
    dialog: {
      title: '添加出口分类',
      categoryName: '分类名称',
      categoryNamePlaceholder: '请输入',
      exitDir: '出口方向',
      exitDirTip: '判断对应元素离开出口的方向。',
      anyDir: '任意朝向',
      fixedDir: '固定朝向',
      emptyWarning: '不能为空',
    },
    categoryTip: '判断运行时是否启用，关闭后，则禁用该元素。',
    selectImage: '选择图片',
    selectArea: '选择区域',
    area: '区域',
    bindEle: '对应元素',
    bindElePlaceholder: '请选择',
    nextWarning: '请先选择{exit}的对应元素。',
  },
  sceneEditorTip: '点这里，可进入快捷布局',
  newGuide: {
    tip1: '先点击选中需要布置到格子内的元素。',
    tip2: '在布局区域点击或滑动放置元素。',
    tip3: '可单击元素进行旋转或移动，也可通过键盘上下左右键进行移动。',
    jump: '跳过',
    next: '下一步',
    know: '知道了',
  },
  resourcePoolTip: '请添加元素头部朝上的图片。',
}
